import MuiRadio, { RadioProps as MuiRadioProps, RadioPropsColorOverrides } from '@mui/material/Radio';
import { OverridableStringUnion } from '@mui/types';
import { forwardRef } from 'react';

declare module '@mui/material/Radio' {
  interface RadioPropsColorOverrides {
    internal: true;
  }
}

export interface RadioProps extends MuiRadioProps {
  color?: OverridableStringUnion<
    'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' | 'internal',
    RadioPropsColorOverrides
  >;
}

const Radio = forwardRef<HTMLButtonElement, RadioProps>((props, ref) => {
  return <MuiRadio ref={ref} {...props} />;
});

Radio.displayName = 'Radio';

export default Radio;
